document.addEventListener("DOMContentLoaded", () => {
  const addToCartForms = document.querySelectorAll("form[action='/cart/add']");

  // Add checkout button listener
  const checkoutButton = document.getElementById("checkout-button");
  if (checkoutButton) {
    checkoutButton.addEventListener("click", handleCheckout);
  }

  addToCartForms.forEach((form) => {
    form.addEventListener("submit", async function (event) {
      event.preventDefault();

      if (this.classList.contains("submitting")) return;
      this.classList.add("submitting");

      // Show loading state
      const buttonLoading = this.querySelector(".button-loading");
      const buttonContent = this.querySelector(".product-page-button-content");
      if (buttonLoading && buttonContent) {
        buttonLoading.style.display = "flex";
        buttonContent.style.display = "none";
      }

      try {
        // Add item to cart
        const variantInput = this.querySelector('input[name="id"]');
        const selectedVariantId = variantInput ? variantInput.value : null;
        const formData = new FormData(this);

        // Add variant image if available
        if (
          selectedVariantId &&
          window.variants &&
          window.variants[selectedVariantId]
        ) {
          const variant = window.variants[selectedVariantId];
          if (variant.images && variant.images.length > 0) {
            formData.append("properties[_variant_image]", variant.images[0]);
          }
        }

        const response = await fetch("/cart/add.js", {
          method: "POST",
          body: formData,
        });
        const data = await response.json();
        console.log("Item added successfully:", data);

        // Update cart UI
        await Promise.all([
          updateCartItems(),
          updateCartCount(),
          updateCartTotal(),
        ]);

        // DOM elements for cart/modal
        const modal = document.getElementById("menu");
        const menuBtn = document.getElementById("menu-toggle");
        const bodyblock = document.getElementById("body-block");
        const menuSections = document.querySelectorAll(".menu-section-wrapper");
        const cartWrapper = document.getElementById("cart-container-wrapper");
        const cartContainer = document.querySelector(".cart-container");
        const returnToMenuBtn = document.getElementById("return-to-menu");
        const menuSVG = document.querySelector(".CL_MENU");
        const closeSVG = document.querySelector(".menu-close");
        const menuGradient = document.querySelector(".menu-gradient");

        // Animation sequence
        await new Promise((resolve) => setTimeout(resolve, 500));
        if (typeof window.hideMenuContainer === "function")
          window.hideMenuContainer();
        if (typeof window.hideMenuContents === "function")
          window.hideMenuContents();

        modal.style.display = "block";
        menuBtn.classList.add("toggled");
        document.body.style.overflow = "hidden";
        bodyblock.style.display = "block";

        if (menuSVG && closeSVG) {
          menuSVG.style.display = "none";
          closeSVG.style.display = "block";
          menuBtn.classList.remove("toggled");
        }

        menuSections.forEach((section) => {
          section.style.display = "none";
        });

        if (menuGradient) menuGradient.style.display = "none";

        cartWrapper.style.opacity = "0";
        cartWrapper.style.display = "flex";
        cartWrapper.style.transition = "opacity 0.5s ease-out";
        cartContainer.style.display = "none";
        returnToMenuBtn.style.display = "flex";

        const dynamicCartItems = document.getElementById("dynamic-cart-items");
        if (dynamicCartItems) dynamicCartItems.scrollTop = 0;

        if (typeof window.fadeInMenuContainer === "function") {
          setTimeout(() => window.fadeInMenuContainer(), 10);
        }

        setTimeout(() => {
          const menuContentWrapper = document.querySelector(
            ".menu-content-wrapper"
          );
          if (menuContentWrapper) menuContentWrapper.style.opacity = "1";
          cartWrapper.style.opacity = "1";
          if (typeof window.initializeCartGradient === "function") {
            window.initializeCartGradient();
          }
        }, 50);
      } catch (error) {
        console.error("Error:", error);
      } finally {
        if (buttonLoading && buttonContent) {
          buttonLoading.style.display = "none";
          buttonContent.style.display = "flex";
        }
        this.classList.remove("submitting");
      }
    });
  });

  initializeRemoveButtons();
});

// Update cart items in the DOM
function updateCartItems() {
  fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {
      const cartContainer = document.getElementById("dynamic-cart-items");
      if (!cartContainer) {
        console.error("Cart container not found!");
        return;
      }
      cartContainer.innerHTML = "";

      if (cart.items && cart.items.length > 0) {
        cart.items.forEach((item) => {
          for (let i = 0; i < item.quantity; i++) {
            const cartItem = document.createElement("div");
            cartItem.className = "cart-item";
            cartItem.style.display = "flex";
            cartItem.style.visibility = "visible";
            cartItem.style.opacity = "1";
            cartItem.dataset.soldOutType1 = "false";
            cartItem.dataset.soldOutType2 = "false";
            cartItem.dataset.variantId = item.variant_id;
            cartItem.dataset.itemKey = item.key;

            let imageSrc = "";
            if (item.properties && item.properties._variant_image) {
              imageSrc = item.properties._variant_image;
            } else if (item.image) {
              imageSrc = item.image;
            }
            if (imageSrc && !imageSrc.includes("_70x")) {
              imageSrc = imageSrc.replace(
                /\.(jpg|jpeg|png|gif|webp)/i,
                "_70x.$1"
              );
            }

            cartItem.innerHTML = `
              <img src="${imageSrc}" alt="${item.title}" loading="eager">
              <div class="sku-price">
                <p>${item.sku || ""}</p>
                <p>${formatLocalizedPrice(item.price)}</p>
              </div>
              <form class="remove-button">
                <input type="hidden" name="id" value="${item.key}">
                <input type="hidden" name="quantity" value="${
                  item.quantity - 1
                }">
                <button type="submit">REMOVE</button>
              </form>
            `;

            const removeForm = cartItem.querySelector(".remove-button");
            removeForm.addEventListener("submit", async function (event) {
              event.preventDefault();
              if (this.classList.contains("submitting")) return;
              this.classList.add("submitting");

              this.classList.add("clicked");
              const cartItem = this.closest(".cart-item");
              const skuPrice = cartItem.querySelector(".sku-price");
              const imgElement = cartItem.querySelector("img");
              if (skuPrice) skuPrice.classList.add("fading-out");
              if (imgElement) imgElement.classList.add("fading-out");

              try {
                const response = await fetch("/cart/change.js", {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({
                    id: this.querySelector('input[name="id"]').value,
                    quantity: parseInt(
                      this.querySelector('input[name="quantity"]').value
                    ),
                  }),
                });
                await response.json();
                await Promise.all([
                  updateCartItems(),
                  updateCartCount(),
                  updateCartTotal(),
                ]);
              } catch (error) {
                console.error("Error removing item:", error);
              } finally {
                this.classList.remove("submitting");
              }
            });

            cartContainer.appendChild(cartItem);
          }
        });
      }
      cartContainer.style.visibility = "visible";
      const totalPriceElement = document.getElementById("cart-total-price");
      if (totalPriceElement) {
        totalPriceElement.textContent = formatLocalizedPrice(cart.total_price);
      }
    })
    .catch((error) => {
      console.error("Error fetching cart:", error);
    });
}

// Format price based on market/currency
function formatLocalizedPrice(cents) {
  const market =
    (window.Shopify && Shopify.currency && Shopify.currency.active) || "USD";
  if (market === "JPY" || market === "JP") {
    return "¥" + Math.round(cents / 100).toLocaleString("ja-JP");
  } else {
    return (
      "$" +
      (cents / 100).toLocaleString("en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      })
    );
  }
}

// Update cart total price
function updateCartTotal() {
  fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {
      const totalPriceElement = document.getElementById("cart-total-price");
      if (totalPriceElement) {
        totalPriceElement.textContent = formatLocalizedPrice(cart.total_price);
      }
      const checkoutButton = document.getElementById("checkout-button");
      if (checkoutButton) {
        checkoutButton.setAttribute(
          "data-formatted-price",
          formatLocalizedPrice(cart.total_price)
        );
      }
    })
    .catch((error) => {
      console.error("Error updating cart total:", error);
    });
}

// Update cart item count
function updateCartCount() {
  fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {
      const cartCountContainer = document.querySelector(
        ".cart-count-container"
      );
      if (cartCountContainer) {
        cartCountContainer.textContent = cart.item_count;
      }
    })
    .catch((error) => {
      console.error("Error updating cart count:", error);
    });
}

// Initialize remove button listeners and cart gradient logic
function initializeRemoveButtons() {
  const existingRemoveButtons = document.querySelectorAll(".remove-button");
  existingRemoveButtons.forEach((removeForm) => {
    removeForm.addEventListener("submit", async function (event) {
      event.preventDefault();
      if (this.classList.contains("submitting")) return;
      this.classList.add("submitting");

      this.classList.add("clicked");
      const cartItem = this.closest(".cart-item");
      const skuPrice = cartItem.querySelector(".sku-price");
      const imgElement = cartItem.querySelector("img");
      if (skuPrice) skuPrice.classList.add("fading-out");
      if (imgElement) imgElement.classList.add("fading-out");

      try {
        const response = await fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: this.querySelector('input[name="id"]').value,
            quantity: parseInt(
              this.querySelector('input[name="quantity"]').value
            ),
          }),
        });
        await response.json();
        await Promise.all([
          updateCartItems(),
          updateCartCount(),
          updateCartTotal(),
        ]);
      } catch (error) {
        console.error("Error removing item:", error);
      } finally {
        this.classList.remove("submitting");
      }
    });
  });

  // Cart gradient logic
  const cartContainer = document.getElementById("dynamic-cart-items");
  const cartGradient = document.querySelector(".cart-gradient");
  let isRemovingItem = false;

  function checkCartScrollable() {
    if (isRemovingItem) return;
    const cart = document.getElementById("cart-container-wrapper");
    if (!cart || window.getComputedStyle(cart).display === "none") return;
    void cartContainer.offsetHeight;
    const isScrollable = cartContainer && cartContainer.scrollHeight > cartContainer.clientHeight;
    if (cartGradient) {
      cartGradient.style.transition = "opacity 0.3s ease-out";
      cartGradient.style.opacity = isScrollable ? "1" : "0";
    }
  }

  // Check gradient on resize
  window.addEventListener("resize", function() {
    if (cartContainer && cartContainer.style.display !== "none") {
      checkCartScrollable();
    }
  });

  // Check gradient after cart updates
  const observer = new MutationObserver(function() {
    if (!isRemovingItem) {
      setTimeout(checkCartScrollable, 100);
    }
  });
  if (cartContainer) {
    observer.observe(cartContainer, { 
      childList: true, 
      subtree: true,
      attributes: true,
      characterData: true 
    });

    // Smooth scroll handling
    cartContainer.addEventListener("scroll", function() {
      if (isRemovingItem) return;
      const scrollMax = cartContainer.scrollHeight - cartContainer.clientHeight;
      const scrollPercent = scrollMax > 0 ? cartContainer.scrollTop / scrollMax : 0;
      if (cartGradient && scrollMax > 0) {
        cartGradient.style.transition = "";
        cartGradient.style.opacity = Math.max(0, 1 - scrollPercent).toString();
      }
    });
  }

  window.startItemRemoval = function () {
    isRemovingItem = true;
    if (cartGradient) {
      cartGradient.style.transition = "none";
      cartGradient.style.opacity = "0";
    }
  };

  window.finishItemRemoval = function () {
    setTimeout(function () {
      if (cartGradient) {
        cartGradient.style.transition = "opacity 0.3s ease";
      }
      isRemovingItem = false;
      checkCartScrollable();
    }, 500);
  };

  window.initializeCartGradient = function () {
    if (isRemovingItem) return;
    setTimeout(checkCartScrollable, 200);
  };

  // Add check after adding items to cart (custom event)
  document.addEventListener("cart:updated", checkCartScrollable);

  // Initial check
  setTimeout(checkCartScrollable, 300);
}

// Handle checkout with sold out item validation
async function handleCheckout(event) {
  // Prevent default checkout behavior
  event.preventDefault();

  try {
    const cartItemsDOM = document.querySelectorAll(".cart-item");

    // Check for sold-out items using getAttribute
    const soldOutItems = Array.from(cartItemsDOM).filter(
      (cartItem) =>
        cartItem.getAttribute("data-sold-out-type1") === "true" ||
        cartItem.getAttribute("data-sold-out-type2") === "true"
    );

    if (soldOutItems.length > 0) {
      // Mark items as sold out visually
      soldOutItems.forEach((cartItem) => {
        const removeButton = cartItem.querySelector(".remove-button button");
        if (removeButton) {
          removeButton.textContent = "SOLD OUT";
        }
      });

      // Small delay to show SOLD OUT text
      await new Promise((resolve) => setTimeout(resolve, 500));

      // Remove items with animation matching regular remove logic
      window.startItemRemoval();

      for (const item of soldOutItems) {
        const removeButton = item.querySelector(".remove-button");
        const skuPrice = item.querySelector(".sku-price");
        const imgElement = item.querySelector("img");

        if (removeButton) removeButton.classList.add("clicked");
        if (skuPrice) skuPrice.classList.add("fading-out");
        if (imgElement) imgElement.classList.add("fading-out");

        // Remove from backend cart
        await fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: item.getAttribute("data-item-key"),
            quantity: 0,
          }),
        });

        // Short delay between each item for smoother animation
        await new Promise((resolve) => setTimeout(resolve, 100));
      }

      // Remove DOM elements after animations complete
      await new Promise((resolve) => setTimeout(resolve, 500));

      soldOutItems.forEach((item) => {
        if (item.parentNode) {
          item.parentNode.removeChild(item);
        }
      });

      window.finishItemRemoval();

      // Update cart UI after removals
      setTimeout(async () => {
        await Promise.all([
          updateCartItems(),
          updateCartCount(),
          updateCartTotal(),
        ]);
      }, 400);

      // Do not proceed to checkout
      return;
    }

    // If we get here, no sold-out items, proceed to checkout
    redirectToCheckout();
  } catch (error) {
    console.error("Error during checkout:", error);
  }
}

// Function to handle checkout redirection with proper locale
function redirectToCheckout() {
  const checkoutButton = document.querySelector(".checkout-link");
  const formattedPrice = checkoutButton.dataset.formattedPrice || "";
  let checkoutUrl = "/checkout";

  if (formattedPrice.includes("¥")) {
    checkoutUrl += "?locale=ja";
  }

  window.location.href = checkoutUrl;
}
